(function ($, Drupal) {
  'use strict';
  $(document).ready(function () {
    var acceptApp = $('.accept-app');
    var dsgvoInfo = $('.dsgvo-info');

    if (readCookie('klaro')) {
      var klaro = JSON.parse(readCookie('klaro'));
      if (klaro && klaro.google_maps) {
        dsgvoInfo.delay(300).fadeOut();
        showStaticMap();
      } else {
        dsgvoInfo.show();
      }
    }
    acceptApp.on('click touch', function (){
      var app = $(this).attr('data-app')
      console.log(app)
      updateCookie('klaro', app);
      dsgvoInfo.delay(300).fadeOut();
      showStaticMap();
    })


  });

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  function updateCookie(name, app) {
    var thatCookie = readCookie(name);
    if (thatCookie) {
      thatCookie = JSON.parse(thatCookie);
      thatCookie[app] = true
      createCookie(name, JSON.stringify(thatCookie), 365);
    }
  }
  function showStaticMap() {
    var linkMap = $('.go-to-google');
    var staticMap = $('img.staticMap');
    var srcMap = staticMap.attr('data-src')
    linkMap.show();
    staticMap.attr('src', srcMap)
  }

})(jQuery, Drupal);